import { EmbeddedAgentView } from "../agentic/EmbeddedAgentView";

// Sprint 8 — Vue D2 agent-first pour /appointments.
// Suggested prompts orientés workflow commercial Théo : trouver créneaux,
// résumé semaine, détection conflits.

const SUGGESTED_PROMPTS = [
  "Trouve mes créneaux libres cette semaine",
  "Détecte les conflits dans mon agenda",
  "Résume mes rendez-vous de la semaine",
  "Compose ma journée de demain",
  "Quelle est ma charge sur les 7 prochains jours ?",
  "Propose des créneaux pour démo Lefèvre",
];

export function AppointmentAgentView() {
  return (
    <EmbeddedAgentView
      pageId="appointments"
      pageLabel="Calendrier"
      suggestedPrompts={SUGGESTED_PROMPTS}
    />
  );
}
